import type { CallCenterV3Types } from "@EspaceParkQC/sdk-services-legacy";

export default function UserParty({
  userPartyDetails,
}: {
  userPartyDetails: CallCenterV3Types.CallPartyUser | undefined;
}): React.ReactElement | null {
  if (!userPartyDetails) return null;

  const name = `${userPartyDetails.userData?.firstName} ${userPartyDetails.userData?.lastName}`;

  return (
    <div className="w-full h-full flex justify-center items-center">
      <h1 className="text-lg font-bold text-center">{name}</h1>
    </div>
  );
}
